'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { motion } from 'motion/react';
import {
  ChartNoAxesCombined,
  CircleDollarSign,
  Clock10,
  Coins,
  Flame,
  Landmark,
  ListOrdered,
  Package,
  Scaling,
  Wallet,
} from 'lucide-react';

const terms = [
  {
    term: 'Age',
    definition: "The time since the token's creation.",
    icon: <Clock10 />,
  },
  {
    term: 'Airdrops',
    definition: 'Free token distributions, often as promotions or rewards.',
    icon: <Package />,
  },
  {
    term: 'ATH (All-Time High)',
    definition: 'The highest price a token has ever reached.',
    icon: <ChartNoAxesCombined />,
  },
  {
    term: 'Bundle',
    definition: 'A negative connotation for a grouped wallet or asset.',
    icon: <Wallet />,
  },
  {
    term: 'Burned',
    definition: 'Tokens permanently removed from circulation to reduce supply.',
    icon: <Flame />,
  },
  {
    term: 'Liq (Liquidity)',
    definition: 'The reserves available for trading in liquidity pools.',
    icon: <CircleDollarSign />,
  },
  {
    term: 'MC (Market Cap)',
    definition: 'The total value of a cryptocurrency: price × supply.',
    icon: <Landmark />,
  },
  {
    term: 'Mint',
    definition: 'The ability of a coin deployer to increase the token supply.',
    icon: <Scaling />,
  },
  {
    term: 'Top Ten',
    definition: 'The ten largest token holders by wallet size.',
    icon: <ListOrdered />,
  },
  {
    term: 'Vol (Volume)',
    definition: 'The total trading activity of a token over a specific time period.',
    icon: <Coins />,
  },
];

const MotionCard = motion.create(Card);

export const Glossary = () => {
  return (
    <div className="border-t border-gray-700 pt-4">
      <h2 className="text-3xl font-bold mb-2">Glossary</h2>
      <h4 className="text-base text-gray-500 mb-4">
        You may already know these, but we wanted to let you guys in on some terminology that is
        important when hunting a rug pull.
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        {terms.map((item, index) => (
          <MotionCard
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                delay: index * 0.025,
              },
            }}
            key={item.term}
            className="bg-transparent border-[rgb(34,50,83)] hover:bg-white/5 transition-all cursor-pointer flex flex-row hover:scale-[1.03]"
          >
            <div className="flex items-center justify-center text-[3rem] text-purple-400 pl-6">
              {item.icon}
            </div>
            <div className="flex flex-col">
              <CardHeader className="pb-2">
                <CardTitle className="text-xl font-semibold text-purple-400 flex flex-row gap-3 items-center justify-start">
                  {item.term}
                </CardTitle>
              </CardHeader>
              <CardContent className="text-gray-200">{item.definition}</CardContent>
            </div>
          </MotionCard>
        ))}
      </div>
    </div>
  );
};
